import React from "react"; 
import CreateOrgForm from "../../mycomp/Authentication/CreateOrgForm";

const CreateOrganization = () => {
  return (
    <>
      <CreateOrgForm />
    </>
  );
};

export default CreateOrganization;
